import React, { useEffect } from 'react';
import { Box, SimpleGrid } from '@chakra-ui/react';
import { useOutletContext, useSearchParams } from 'react-router-dom';

import { useReduxDispatch } from '../../app/store';
import { BOTTOM_NAV_HEIGHT, PAGE_SPACING_PER_VIEWPORT } from '../../common/constants';
import { useViewportType } from '../../common/hooks/use-viewport-type';
import { billsApi } from './billsApi';
import { CurrentBillPeriod } from './CurrentBillPeriod';
import { EnergyPlan } from './energy-plan/EnergyPlan';
import { UploadBillBottomDrawer, UploadBillModal } from './energy-plan/upload-bill/UploadBill';
import { PastBills } from './past-bills/PastBills';
import { BillsOutletContext } from './SiteBills';
import { TariffsList } from './tariffs/TariffsList';

export function BillsHome() {
  const { tariffs, isParentLoaded, onOpenUploadBillDialog, isOpenUploadBillDialog, onCloseUploadBillDialog } =
    useOutletContext<BillsOutletContext>();
  const { isDesktopViewport } = useViewportType();
  const dispatch = useReduxDispatch();
  // Handlers for bill upload dialog (bottom drawer on mobile, modal on desktop)
  const [search] = useSearchParams();
  const billUrl = search.get('bill-url');

  useEffect(() => {
    if (billUrl) onOpenUploadBillDialog();
  }, [billUrl, onOpenUploadBillDialog]);

  async function handleReset() {
    dispatch(billsApi.util.resetApiState());
  }

  return (
    <>
      <Box
        data-testid="site-bills"
        mb={isDesktopViewport ? 4 : BOTTOM_NAV_HEIGHT}
        mt={4}
        mx={PAGE_SPACING_PER_VIEWPORT}
      >
        <EnergyPlan onOpenUploadBillDialog={onOpenUploadBillDialog} isParentLoaded={isParentLoaded} />
        <SimpleGrid gridGap={5} pt={5} columns={[1, 1, 2]}>
          {!!tariffs?.results?.length && <CurrentBillPeriod isParentLoaded={isParentLoaded} />}
          <PastBills onOpenUploadBillDialog={onOpenUploadBillDialog} />
          <TariffsList isParentLoaded={isParentLoaded} />
        </SimpleGrid>
      </Box>

      {isDesktopViewport ? (
        <UploadBillModal onResetBills={handleReset} isOpen={isOpenUploadBillDialog} onClose={onCloseUploadBillDialog} />
      ) : (
        <UploadBillBottomDrawer
          onResetBills={handleReset}
          isOpen={isOpenUploadBillDialog}
          onClose={onCloseUploadBillDialog}
          billUrl={billUrl}
        />
      )}
    </>
  );
}
